import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const SaveDashboard = (props: SvgIconProps) => {
  return (
    <SvgIcon
      height='24'
      viewBox='0 0 14 14'
      width='24'
      {...props}
    >
      <path
        d='M6.37308 8.19583L9.6835 4.9L8.85225 4.06875L6.37308 6.54792L5.1335 5.30833L4.31683 6.125L6.37308 8.19583ZM0.583496 12.25V11.0833H13.4168V12.25H0.583496ZM1.16683 10.5V1.75H12.8335V10.5H1.16683ZM2.3335 9.33333H11.6668V2.91667H2.3335V9.33333Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
};

export default SaveDashboard;
